export default __webpack_public_path__ + "static/media/event_popup_signup.fde06e44.png";